import {
    FieldInCard,
} from 'app/types/form.types'

import {
    CommentType,
} from '../CommentsLog.types'

const fields: FieldInCard<keyof CommentType>[] = [{
    title: 'New Comment',
    fields: [{
        name: 'comment',
        componentName: 'LongText',
        required: true,
        labelKey: 'OrderComment.comment',
    }],
}]

export default fields
